import { STORAGE_KEY } from '/@/constants/storage';
import { TOKEN_KEY } from '/@/enums/cacheEnum';
import { useModalForTokenExpired } from '/@/hooks/web/useModalForTokenExpired';
import { LangEnum, LangPrefixEnum } from '/@/enums/appEnum';
import { onMounted } from 'vue';
import { useLocale } from '/@/locales/useLocale';

export function useAppStorage() {
  // 监听Storage变化
  const modalForTokenExpired = useModalForTokenExpired();
  window.addEventListener('storage', function (e) {
    if (e.key === TOKEN_KEY) {
      const token = e.newValue || '';
      modalForTokenExpired(token);
    }
  });

  // 设置语言
  const { changeLocale } = useLocale();
  const lang =
    window.localStorage.getItem(STORAGE_KEY.lang) ||
    LangPrefixEnum[navigator.language.slice(0, 2)] ||
    LangEnum.EN_US;

  onMounted(async () => {
    await changeLocale(lang as LangEnum);
  });
}
